(function () {
  'use strict';

  var scrubPage = document.querySelector('.scrub-page');
  var variantsEl = document.getElementById('scrub-variants-json');
  var colorImagesEl = document.getElementById('scrub-color-images-json');
  var legacyImagesEl = document.getElementById('scrub-images-json');
  var galleryImagesEl = document.getElementById('scrub-gallery-images-json');
  var optionsEl = document.getElementById('scrub-options-json');

  if (!variantsEl) return;

  var variants = JSON.parse(variantsEl.textContent);
  var colorImages = colorImagesEl ? JSON.parse(colorImagesEl.textContent.trim()) : [];
  var legacyVariantImages = legacyImagesEl ? JSON.parse(legacyImagesEl.textContent.trim()) : [];
  var galleryImages = galleryImagesEl ? JSON.parse(galleryImagesEl.textContent.trim()) : [];
  var scrubOptions = optionsEl ? JSON.parse(optionsEl.textContent) : {};
  var colorOptionIndex = typeof scrubOptions.color_index === 'number' ? scrubOptions.color_index : 0;
  var upperOptionIndex = typeof scrubOptions.upper_index === 'number' ? scrubOptions.upper_index : 1;
  var lowerOptionIndex = typeof scrubOptions.lower_index === 'number' ? scrubOptions.lower_index : 2;
  var hasColorOption = scrubOptions.color_index !== null && scrubOptions.color_index !== undefined;
var hasUpperOption = scrubOptions.upper_index !== null && scrubOptions.upper_index !== undefined;
  var hasLowerOption = scrubOptions.lower_index !== null && scrubOptions.lower_index !== undefined;


  var selectedColor = null;
  var selectedUpperSize = null;
  var selectedLowerSize = null;

  var mainImage = document.getElementById('scrub-main-image');
  var thumbsContainer = scrubPage ? scrubPage.querySelector('.scrub-gallery__thumbs') : document.querySelector('.scrub-gallery__thumbs');
  var thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('.scrub-gallery__thumb') : document.querySelectorAll('.scrub-gallery__thumb');
  var colorSwatches = scrubPage ? scrubPage.querySelectorAll('.scrub-swatch') : document.querySelectorAll('.scrub-swatch');
  var upperBtns = document.querySelectorAll('.scrub-size-btn[data-option="upper"]');
  var lowerBtns = document.querySelectorAll('.scrub-size-btn[data-option="lower"]');
  var priceEl = document.getElementById('scrub-price');
  var compareEl = document.getElementById('scrub-compare-price');
  var selectedColorEl = document.getElementById('selected-color');
  var selectedUpperEl = document.getElementById('selected-upper-size');
  var selectedLowerEl = document.getElementById('selected-lower-size');
  var atcBtn = document.getElementById('scrub-atc-btn');
  var qtyInput = document.getElementById('scrub-qty');
  var qtyMinus = document.getElementById('qty-minus');
  var qtyPlus = document.getElementById('qty-plus');

  var basePriceCents = null; // tracks the current variant's own price, in cents

  function getVariantOption(variant, index) {
    if (!variant || typeof index !== 'number') return null;
    if (index === 0) return variant.option1;
    if (index === 1) return variant.option2;
    if (index === 2) return variant.option3;
    return null;
  }

  function getVariantColor(variant) {
    if (!variant) return null;
    if (colorOptionIndex === 0) return variant.option1;
    if (colorOptionIndex === 1) return variant.option2;
    if (colorOptionIndex === 2) return variant.option3;
    return variant.option1 || variant.option2 || variant.option3;
  }

  function normalizeColor(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function slugify(value) {
    return normalizeColor(value).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function normalizeSrc(src) {
    if (!src) return '';
    return src.split('?')[0];
  }

  function thumbSrcFromMain(src) {
    if (!src) return '';
    return src.indexOf('width=') !== -1 ? src.replace(/width=\d+/, 'width=150') : src;
  }

  function getGalleryImageByLinkedColor(color) {
    var norm = normalizeColor(color);
    for (var i = 0; i < galleryImages.length; i++) {
      var linked = galleryImages[i].linked_colors || [];
      for (var j = 0; j < linked.length; j++) {
        if (normalizeColor(linked[j]) === norm) {
          return galleryImages[i].src;
        }
      }
    }
    return null;
  }

  // Scan ALL variants for this color — pick the featured_image that appears most often.
  // Fixes wrong image when only the first variant in JSON has a bad featured_image.
  function getMajorityVariantImageForColor(color) {
    var norm = normalizeColor(color);
    var counts = {};
    var order = [];

    variants.forEach(function(variant) {
      if (normalizeColor(getVariantColor(variant)) !== norm) return;
      var img = variant.featured_image;
      if (!img || !img.src) return;
      if (!counts[img.src]) {
        counts[img.src] = 0;
        order.push(img.src);
      }
      counts[img.src] += 1;
    });

    var bestSrc = null;
    var bestCount = 0;
    order.forEach(function(src) {
      if (counts[src] > bestCount) {
        bestCount = counts[src];
        bestSrc = src;
      }
    });
    return bestSrc;
  }

  function getVariantFeaturedImagesForColor(color) {
    var norm = normalizeColor(color);
    var result = [];
    variants.forEach(function(variant) {
      if (normalizeColor(getVariantColor(variant)) !== norm) return;
      if (variant.featured_image && variant.featured_image.src) {
        result.push({
          variant_id: variant.id,
          options: [variant.option1, variant.option2, variant.option3],
          src: variant.featured_image.src
        });
      }
    });
    return result;
  }

  function resolveColorImage(color) {
    if (!color) return null;

    var byLinked = getGalleryImageByLinkedColor(color);
    if (byLinked) return byLinked;

    var mediaEntry = colorImages.find(function(e) { return e.color === color; });
    if (mediaEntry && mediaEntry.media_linked_src) return mediaEntry.media_linked_src;

    var byMajority = getMajorityVariantImageForColor(color);
    if (byMajority) return byMajority;

    return null;
  }

  function getGalleryImagesForColor(color) {
    var norm = normalizeColor(color);
    var result = galleryImages.filter(function(img) {
      return (img.linked_colors || []).some(function(c) {
        return normalizeColor(c) === norm;
      });
    });
    if (result.length) return result;

    var src = resolveColorImage(color);
    if (src) {
      return [{ id: 'color-' + norm, src: src, alt: '', position: 0 }];
    }

    return galleryImages.slice(0, 4);
  }

  function syncActiveThumb(imageSrc) {
    if (!imageSrc || !thumbsContainer) return;
    var norm = normalizeSrc(imageSrc);
    var matched = false;
    thumbsContainer.querySelectorAll('.scrub-gallery__thumb').forEach(function(thumb) {
      var isMatch = normalizeSrc(thumb.dataset.imageSrc) === norm;
      thumb.classList.toggle('active', isMatch);
      if (isMatch) matched = true;
    });
    if (!matched) {
      var first = thumbsContainer.querySelector('.scrub-gallery__thumb');
      if (first) first.classList.add('active');
    }
  }

  function updateThumbnailsForColor(color, activeSrc) {
    if (!thumbsContainer) return;
    var images = getGalleryImagesForColor(color);
    if (!images.length) return;

    var activeNorm = activeSrc ? normalizeSrc(activeSrc) : normalizeSrc(images[0].src);
    thumbsContainer.innerHTML = '';

    images.forEach(function(img) {
      var thumb = document.createElement('div');
      var isActive = normalizeSrc(img.src) === activeNorm;
      thumb.className = 'scrub-gallery__thumb' + (isActive ? ' active' : '');
      thumb.dataset.imageSrc = img.src;
      thumb.dataset.imageId = img.id;

      var thumbImg = document.createElement('img');
      thumbImg.src = thumbSrcFromMain(img.src);
      thumbImg.alt = img.alt || '';
      thumbImg.width = 150;
      thumbImg.height = 150;
      thumbImg.loading = 'lazy';
      thumb.appendChild(thumbImg);
      thumbsContainer.appendChild(thumb);
    });

    thumbs = thumbsContainer.querySelectorAll('.scrub-gallery__thumb');
  }

  function buildColorImageMap() {
    var map = {};
    var colors = [];

    colorSwatches.forEach(function(swatch) {
      if (swatch.dataset.color) colors.push(swatch.dataset.color);
    });

    if (!colors.length && scrub_color_option_values) {
      colors = scrub_color_option_values;
    }

    colorImages.forEach(function(entry) {
      if (entry.color && colors.indexOf(entry.color) === -1) colors.push(entry.color);
    });

    colors.forEach(function(color) {
      var src = resolveColorImage(color);
      if (src) map[color] = src;
    });

    return map;
  }

  var scrub_color_option_values = window.scrubColorDebug || [];
  var colorImageMap = buildColorImageMap();

  function debugScrubProduct() {
    var enabled = /(?:\?|&)scrub_debug=1(?:&|$)/.test(window.location.search) || window.SCRUB_DEBUG;
    if (!enabled) return;

    var lines = [];
    lines.push('=== SCRUB PRODUCT RAW DATA ===');
    lines.push('Product: ' + (window.scrubProductTitle || document.title));
    lines.push('Color option index: ' + colorOptionIndex);
    lines.push('Total variants: ' + variants.length);
    lines.push('Gallery images: ' + galleryImages.length);
    lines.push('');

    lines.push('--- GALLERY (Media section) ---');
    galleryImages.forEach(function(img) {
      var linked = (img.linked_colors && img.linked_colors.length)
        ? img.linked_colors.join(', ')
        : '(no variants linked)';
      lines.push('#' + (img.position + 1) + ' id=' + img.id);
      lines.push('  file: ' + img.src);
      lines.push('  alt: ' + (img.alt || '(empty)'));
      lines.push('  linked colors: ' + linked);
    });

    lines.push('');
    lines.push('--- PER COLOR ---');
    colorSwatches.forEach(function(swatch, index) {
      var color = swatch.dataset.color;
      var mediaLinked = getGalleryImageByLinkedColor(color);
      var variantImgs = getVariantFeaturedImagesForColor(color);
      var uniqueSrcs = {};
      variantImgs.forEach(function(v) {
        uniqueSrcs[v.src] = (uniqueSrcs[v.src] || 0) + 1;
      });
      var resolved = resolveColorImage(color);

      lines.push((index + 1) + '. ' + color);
      lines.push('  [Media linked]     ' + (mediaLinked || 'NONE — link in Admin → Media → Select variant'));
      lines.push('  [Variant images]   ' + (Object.keys(uniqueSrcs).length
        ? Object.keys(uniqueSrcs).map(function(src) {
            return uniqueSrcs[src] + ' variants → ' + src.split('/').pop();
          }).join(' | ')
        : 'NONE — no variant has featured_image'));
      lines.push('  [Code will show]   ' + (resolved || 'NO IMAGE — fix in Shopify Admin'));
      lines.push('');
    });

    lines.push('Full colorImageMap:');
    lines.push(JSON.stringify(colorImageMap, null, 2));

    var output = lines.join('\n');
    console.group('[Scrub Product RAW DATA]');
    console.log(output);
    console.log('galleryImages', galleryImages);
    console.log('colorImages (media linked from Liquid)', colorImages);
    console.log('variants sample (first 3)', variants.slice(0, 3));
    console.groupEnd();

    var panel = document.getElementById('scrub-debug-panel');
    if (panel) {
      panel.hidden = false;
      panel.style.display = 'block';
      panel.textContent = output;
    }
  }

  // ---------------------------------------------------------------------
  // VARIANT / COLOR / SIZE LOGIC
  // ---------------------------------------------------------------------

  function findVariantByColor(color) {
    if (!color) return null;
    return variants.find(function(v) {
      return getVariantOption(v, colorOptionIndex) === color;
    });
  }

  function findColorFromHandle() {
    var handle = scrubPage && scrubPage.dataset.productHandle;
    if (!handle) return null;

    var handleSlug = handle.toLowerCase();
    var bestMatch = null;
    var bestLen = 0;

    colorSwatches.forEach(function(swatch) {
      var color = swatch.dataset.color;
      var colorSlug = slugify(color);
      if (!colorSlug) return;
      if (handleSlug === colorSlug || handleSlug.endsWith('-' + colorSlug)) {
        if (colorSlug.length > bestLen) {
          bestLen = colorSlug.length;
          bestMatch = color;
        }
      }
    });

    return bestMatch;
  }

  function getVariantSizeOptions(variant) {
    if (!variant) return { upper: null, lower: null };
    return {
      upper: getVariantOption(variant, upperOptionIndex),
      lower: getVariantOption(variant, lowerOptionIndex)
    };
  }

  function getInitialVariant() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant') || params.get('v');

    var initialEl = document.getElementById('scrub-initial-json');
    if (initialEl) {
      try {
        var initial = JSON.parse(initialEl.textContent);
        if (!variantId && initial.selected_variant_id) {
          variantId = initial.selected_variant_id;
        }
      } catch (e) { /* ignore */ }
    }

    if (variantId) {
      var byId = variants.find(function(v) { return String(v.id) === String(variantId); });
      if (byId) return byId;
    }

    var colorFromHandle = findColorFromHandle();
    if (colorFromHandle) return findVariantByColor(colorFromHandle);

    return null;
  }

  function selectColor(color, imageSrc) {
    colorSwatches.forEach(function(s) {
      s.classList.toggle('active', s.dataset.color === color);
    });
    selectedColor = color;
    if (selectedColorEl) selectedColorEl.textContent = color;

    var resolvedSrc = imageSrc || resolveColorImage(color);
    if (resolvedSrc) {
      updateThumbnailsForColor(color, resolvedSrc);
      setMainImage(resolvedSrc);
    } else {
      updateThumbnailsForColor(color);
      var colorVariant = findVariantByColor(color);
      if (colorVariant) updateImage(colorVariant, color);
    }

    var activeSwatch = Array.prototype.find.call(colorSwatches, function(s) {
      return s.dataset.color === color;
    });
    if (activeSwatch) updateEmbColorBox(activeSwatch);

    updateATC();
  }

  function applyVariantToUi(variant) {
    if (!variant) return false;

    var color = hasColorOption ? getVariantColor(variant) : null;
    if (hasColorOption && !color) return false;

   var sizes = getVariantSizeOptions(variant);
    if (hasUpperOption && !sizes.upper) return false;
    if (hasLowerOption && !sizes.lower) return false;
    
    selectedColor = color;
    selectedUpperSize = sizes.upper;
    selectedLowerSize = sizes.lower;

    if (hasColorOption && color) {
      colorSwatches.forEach(function(s) {
        s.classList.toggle('active', s.dataset.color === color);
      });
      if (selectedColorEl) selectedColorEl.textContent = color;
    }

    upperBtns.forEach(function(b) {
      b.classList.toggle('active', sizes.upper && b.dataset.value === sizes.upper);
    });
    if (selectedUpperEl && sizes.upper) selectedUpperEl.textContent = sizes.upper;

    lowerBtns.forEach(function(b) {
      b.classList.toggle('active', sizes.lower && b.dataset.value === sizes.lower);
    });
    if (selectedLowerEl && sizes.lower) selectedLowerEl.textContent = sizes.lower;

    if (hasColorOption && color) {
      var resolvedSrc = resolveColorImage(color);
      updateThumbnailsForColor(color, resolvedSrc);
      if (resolvedSrc) {
        setMainImage(resolvedSrc);
      } else {
        updateImage(variant, color);
      }

      var activeSwatch = Array.prototype.find.call(colorSwatches, function(s) {
        return s.dataset.color === color;
      });
      if (activeSwatch) updateEmbColorBox(activeSwatch);
    } else {
      updateImage(variant, null);
    }

    updateATC();
    return true;
  }

  function findVariant() {
    if (hasColorOption && !selectedColor) return null;
    if (hasUpperOption && !selectedUpperSize) return null;
    if (hasLowerOption && !selectedLowerSize) return null;

    return variants.find(function(v) {
      var colorMatch = !hasColorOption || getVariantOption(v, colorOptionIndex) === selectedColor;
      var upperMatch = !hasUpperOption || getVariantOption(v, upperOptionIndex) === selectedUpperSize;
      var lowerMatch = !hasLowerOption || getVariantOption(v, lowerOptionIndex) === selectedLowerSize;
      return colorMatch && upperMatch && lowerMatch;
    });
  }

  function formatMoney(cents) {
    var formatter = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 });
    return formatter.format(cents / 100);
  }

  function updatePrice(variant) {
    if (!variant || !priceEl) return;
    basePriceCents = variant.price;
    renderPrice();
    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = 'inline';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }

  // Renders base price + embroidery add-on together, so the displayed
  // price always reflects whatever embroidery is currently applied.
  function renderPrice() {
    if (basePriceCents === null || !priceEl) return;
    var embCents = (window.embroideryData && window.embroideryData.priceCents) || 0;
    priceEl.textContent = formatMoney(basePriceCents + embCents);

    var noteEl = document.getElementById('scrub-emb-price-note');
    if (noteEl) {
      if (embCents > 0) {
        noteEl.textContent = '+ ' + formatMoney(embCents) + ' embroidery';
        noteEl.classList.add('is-visible');
      } else {
        noteEl.classList.remove('is-visible');
      }
    }
  }

  function setMainImage(imageSrc) {
    if (!imageSrc || !mainImage) return;
    mainImage.style.opacity = '0';
    setTimeout(function() {
      mainImage.src = imageSrc;
      mainImage.style.opacity = '1';
      syncActiveThumb(imageSrc);
    }, 200);
  }

  function findImageForColor(color) {
    return resolveColorImage(color);
  }

  function updateImage(variant, color) {
    if (!mainImage) return;
    var imageSrc = color ? findImageForColor(color) : null;
    if (!imageSrc && variant) {
      var match = legacyVariantImages.find(function(v) { return v.variant_id === variant.id; });
      if (match) imageSrc = match.image_src;
      if (!imageSrc && variant.featured_image && variant.featured_image.src) {
        imageSrc = variant.featured_image.src;
      }
    }
    if (imageSrc) setMainImage(imageSrc);
  }

  function updateATC() {
    if (!atcBtn) return;

    var variant = findVariant();
    if (!variant) {
      var firstAvailable = variants.find(function(v) { return v.available; }) || variants[0];
      var noSelections = !selectedUpperSize && !selectedLowerSize &&
        (!hasColorOption || !selectedColor);
      if (firstAvailable && noSelections) {
        atcBtn.dataset.variantId = firstAvailable.id;
        atcBtn.disabled = false;
        atcBtn.textContent = 'ADD TO CART';
        updatePrice(firstAvailable);
        updateImage(firstAvailable, selectedColor);
        return;
      }
      atcBtn.disabled = true;
      atcBtn.textContent = 'SELECT OPTIONS';
      return;
    }
    atcBtn.dataset.variantId = variant.id;
    if (!variant.available) {
      atcBtn.disabled = true;
      atcBtn.textContent = 'SOLD OUT';
    } else {
      atcBtn.disabled = false;
      atcBtn.textContent = 'ADD TO CART';
    }
    updatePrice(variant);
    updateImage(variant, selectedColor);
  }

  function updateEmbColorBox(swatchEl) {
    var shirtBody = document.getElementById('emb-preview-shirt-body');
    var shirtCollar = document.getElementById('emb-preview-shirt-collar');
    if (!shirtBody || !swatchEl) return;
    var bg = swatchEl.style.backgroundColor;
    if (bg) {
      shirtBody.setAttribute('fill', bg);
      if (shirtCollar) shirtCollar.setAttribute('fill', bg);
    }
  }

  colorSwatches.forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      var color = swatch.dataset.color;
      var imageSrc = resolveColorImage(color);
      if (!imageSrc) {
        console.warn('[Scrub Product] No image for color:', color, {
          mediaLinked: getGalleryImageByLinkedColor(color),
          variantImages: getVariantFeaturedImagesForColor(color).length,
          hint: 'Shopify Admin → Media → image → Select variant → pick ALL sizes for this color'
        });
      }
      selectColor(color, imageSrc);
    });
  });

  upperBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      upperBtns.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      selectedUpperSize = btn.dataset.value;
      if (selectedUpperEl) selectedUpperEl.textContent = selectedUpperSize;
      updateATC();
    });
  });

  lowerBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      lowerBtns.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      selectedLowerSize = btn.dataset.value;
      if (selectedLowerEl) selectedLowerEl.textContent = selectedLowerSize;
      updateATC();
    });
  });

  if (thumbsContainer) {
    thumbsContainer.addEventListener('click', function(e) {
      var thumb = e.target.closest('.scrub-gallery__thumb');
      if (!thumb) return;
      thumbsContainer.querySelectorAll('.scrub-gallery__thumb').forEach(function(t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
      if (mainImage && thumb.dataset.imageSrc) {
        setMainImage(thumb.dataset.imageSrc);
      }
    });
  }

  if (qtyMinus) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value);
      if (val > 1) qtyInput.value = val - 1;
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value);
      if (val < 99) qtyInput.value = val + 1;
    });
  }

  // ---------------------------------------------------------------------
  // ADD TO CART (main product + hidden embroidery charge line item)
  // ---------------------------------------------------------------------

  if (atcBtn) {
    atcBtn.addEventListener('click', function() {
      var variantId = atcBtn.dataset.variantId;
      var qty = parseInt(qtyInput.value) || 1;
      if (!variantId) return;

      atcBtn.disabled = true;
      atcBtn.textContent = 'ADDING...';

      var items = [{ id: variantId, quantity: qty }];

      var chargeVariantId = window.embroideryData && window.embroideryData.chargeVariantId;
      var hasValidChargeVariant = chargeVariantId &&
        String(chargeVariantId).trim() !== '' &&
        !isNaN(Number(chargeVariantId)) &&
        Number(chargeVariantId) > 0;

      if (window.embroideryData && window.embroideryData.applied) {
        if (hasValidChargeVariant) {
          var chargeProps = {
            'For Product': (window.scrubProductTitle || document.title),
            'Color': selectedColor || '-',
            'Top Size': selectedUpperSize || '-',
            'Bottom Size': selectedLowerSize || '-',
            'Font Style': window.embroideryData.font_style_label || '-',
            'Font Color': window.embroideryData.font_color_label || '-',
            'Text Placement': window.embroideryData.placement || '-',
            'Name': window.embroideryData.line1 || '-',
            'Department': window.embroideryData.line2 || '-',
            'Other': window.embroideryData.line3 || '-'
          };

          items.push({
            id: Number(chargeVariantId),
            quantity: qty,
            properties: chargeProps
          });
        } else {
          console.warn(
            'Embroidery was applied, but no valid "Embroidery Charge" variant ID is configured ' +
            'in the Embroidery block settings. The embroidery charge line item was skipped so the ' +
            'main product could still be added to cart. Set the Variant ID fields in the theme editor ' +
            'to enable the separate embroidery charge line.'
          );
        }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(res) {
        if (!res.ok) {
          return res.json().then(function(errData) {
            throw new Error((errData && errData.description) || 'Cart add failed');
          });
        }
        return res.json();
      })
      .then(function() {
        var atcError = document.getElementById('scrub-atc-error');
        if (atcError) atcError.classList.remove('is-visible');

        if (typeof theme !== 'undefined' && theme.miniCart) {
          theme.miniCart.updateElements();
          theme.miniCart.generateCart();
        }

        atcBtn.textContent = 'ADDED ✓';
        atcBtn.style.background = '#1b4332';
        setTimeout(function() {
          atcBtn.disabled = false;
          atcBtn.textContent = 'ADD TO CART';
          atcBtn.style.background = '';
          // window.location.href = '/cart'; // ← redirect after 2s

              }, 2000);
      })
      .catch(function(err) {
        console.error('Add to cart failed:', err);
        atcBtn.disabled = false;
        atcBtn.textContent = 'ADD TO CART';
        var atcError = document.getElementById('scrub-atc-error');
        if (atcError) {
          atcError.textContent = 'Something went wrong. Please try again.';
          atcError.classList.add('is-visible');
        }
      });
    });
  }

  // ---------------------------------------------------------------------
  // TABS
  // ---------------------------------------------------------------------

  var tabBtns = document.querySelectorAll('.scrub-tab-btn');
  var tabPanels = document.querySelectorAll('.scrub-tab-panel');
  tabBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      tabBtns.forEach(function(b) { b.classList.remove('active'); });
      tabPanels.forEach(function(p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var target = document.getElementById('tab-' + btn.dataset.tab);
      if (target) target.classList.add('active');
    });
  });

  debugScrubProduct();
  var initialVariant = getInitialVariant();
  if (initialVariant && applyVariantToUi(initialVariant)) {
    /* variant from URL, ?v=, or product handle */
  } else if (colorSwatches.length > 0) {
    selectColor(colorSwatches[0].dataset.color);
  } else if (variants.length) {
    updateATC();
  }

  // ---------------------------------------------------------------------
  // EMBROIDERY POPUP
  // ---------------------------------------------------------------------

  var embTrigger = document.getElementById('embroidery-trigger');
  var embPopup = document.getElementById('emb-popup');
  var embOverlay = document.getElementById('emb-overlay');
  var embClose = document.getElementById('emb-close');
  var embCancel = document.getElementById('emb-cancel');
  var embApply = document.getElementById('emb-apply');

  if (!embTrigger || !embPopup) return;

  var embConfigEl = document.getElementById('emb-config-json');
  var embConfig = embConfigEl ? JSON.parse(embConfigEl.textContent) : {
    price_1_2_lines: 1000,
    price_3_lines: 1500,
    variant_1_2_lines: null,
    variant_3_lines: null
  };

  var embSummary = document.getElementById('emb-summary');
  var embSummaryImg = document.getElementById('emb-summary-img');
  var embSummaryCost = document.getElementById('emb-summary-cost');
  var embSummaryFont = document.getElementById('emb-summary-font');
  var embSummaryColor = document.getElementById('emb-summary-color');
  var embSummaryPlacement = document.getElementById('emb-summary-placement');
  var embSummaryNameRow = document.getElementById('emb-summary-name-row');
  var embSummaryName = document.getElementById('emb-summary-name');
  var embSummaryDepartmentRow = document.getElementById('emb-summary-department-row');
  var embSummaryDepartment = document.getElementById('emb-summary-department');
  var embSummaryOtherRow = document.getElementById('emb-summary-other-row');
  var embSummaryOther = document.getElementById('emb-summary-other');
  var embSummaryEdit = document.getElementById('emb-summary-edit');
  var embSummaryRemove = document.getElementById('emb-summary-remove');

  var embLine1 = document.getElementById('emb-line1');
  var embLine2 = document.getElementById('emb-line2');
  var embLine3 = document.getElementById('emb-line3');
  var embCounter1 = document.getElementById('emb-counter1');
  var embCounter2 = document.getElementById('emb-counter2');
  var embCounter3 = document.getElementById('emb-counter3');
  var embFontStyle = document.getElementById('emb-font-style');
  var embFontColor = document.getElementById('emb-font-color');
  var embPlacement = document.getElementById('emb-placement');
  var embPopupPriceLabel = document.getElementById('emb-popup-price-label');

  var embPreviewLiveText = document.getElementById('emb-preview-live-text');
  var scrubOverlayText = document.getElementById('scrub-emb-overlay');

  function openEmb() {
    embOverlay.style.display = 'block';
    embPopup.style.display = 'block';
    setTimeout(function() {
      embOverlay.classList.add('open');
      embPopup.classList.add('open');
    }, 10);
    document.body.style.overflow = 'hidden';
    clearEmbError();
  }

  function closeEmb() {
    embOverlay.classList.remove('open');
    embPopup.classList.remove('open');
    setTimeout(function() {
      embOverlay.style.display = 'none';
      embPopup.style.display = 'none';
    }, 300);
    document.body.style.overflow = '';
  }

  embTrigger.addEventListener('click', openEmb);
  if (embClose) embClose.addEventListener('click', closeEmb);
  if (embCancel) embCancel.addEventListener('click', closeEmb);
  if (embOverlay) embOverlay.addEventListener('click', closeEmb);

  function setupCounter(input, counter) {
    if (!input || !counter) return;
    input.addEventListener('input', function() {
      counter.textContent = this.value.length + '/25';
      updateLivePreview();
    });
  }

  setupCounter(embLine1, embCounter1);
  setupCounter(embLine2, embCounter2);
  setupCounter(embLine3, embCounter3);

  function buildPreviewText() {
    var lines = [embLine1, embLine2, embLine3]
      .map(function(el) { return el ? el.value.trim() : ''; })
      .filter(function(v) { return v.length > 0; });
    return lines.join('\n');
  }

 function applyTextStyles(el, fontFamily, color, placement) {
    if (!el) return;
    el.style.fontFamily = fontFamily || "'Brush Script MT', cursive";
    el.style.color = color || '#ffffff';
    el.setAttribute('data-placement', placement || 'Left Chest');

    // Position sidha ethe set kar rahe haan, CSS de bharose nahi.
    el.style.position = 'absolute';
    el.style.transform = 'none';
    el.style.top = '36%';
    if (placement === 'Left Chest') {
      el.style.left = 'auto';
      el.style.right = '30%';
      el.style.textAlign = 'right';
    } else {
      el.style.left = '30%';
      el.style.right = 'auto';
      el.style.textAlign = 'left';
    }
  }

  function updateLivePreview() {
    var text = buildPreviewText();
    var fontFamily = embFontStyle ? embFontStyle.value : '';
    var color = embFontColor ? embFontColor.value : '';
    var placement = embPlacement ? embPlacement.value : '';

    if (embPreviewLiveText) {
      embPreviewLiveText.textContent = text;
      applyTextStyles(embPreviewLiveText, fontFamily, color, placement);
      if (text.length > 0) {
        embPreviewLiveText.classList.add('is-visible');
      } else {
        embPreviewLiveText.classList.remove('is-visible');
      }
    }

    var lineCount = [embLine1, embLine2, embLine3].filter(function(el) {
      return el && el.value.trim().length > 0;
    }).length;
    if (embPopupPriceLabel) {
      var liveCents = lineCount >= 3 ? embConfig.price_3_lines : embConfig.price_1_2_lines;
      embPopupPriceLabel.textContent = formatMoney(liveCents);
    }
  }

  if (embLine1) embLine1.addEventListener('input', updateLivePreview);
  if (embLine2) embLine2.addEventListener('input', updateLivePreview);
  if (embLine3) embLine3.addEventListener('input', updateLivePreview);
  if (embFontStyle) embFontStyle.addEventListener('change', updateLivePreview);
  if (embFontColor) embFontColor.addEventListener('change', updateLivePreview);
  if (embPlacement) embPlacement.addEventListener('change', updateLivePreview);

  function fontLabel(value) {
    if (!embFontStyle) return value;
    for (var i = 0; i < embFontStyle.options.length; i++) {
      if (embFontStyle.options[i].value === value) {
        return embFontStyle.options[i].textContent;
      }
    }
    return value;
  }
  function colorLabel(value) {
    if (!embFontColor) return value;
    for (var i = 0; i < embFontColor.options.length; i++) {
      if (embFontColor.options[i].value === value) {
        return embFontColor.options[i].textContent;
      }
    }
    return value;
  }

  function setSummaryTextLine(rowEl, spanEl, value) {
    if (!rowEl || !spanEl) return;
    if (value) {
      spanEl.textContent = value;
      rowEl.style.display = '';
    } else {
      spanEl.textContent = '';
      rowEl.style.display = 'none';
    }
  }

  function renderSummary(data) {
    if (!embSummary) return;
    embSummaryCost.textContent = '(+ ' + formatMoney(data.priceCents) + ')';
    embSummaryFont.textContent = data.font_style_label;
    embSummaryColor.textContent = data.font_color_label;
    embSummaryPlacement.textContent = data.placement;
    setSummaryTextLine(embSummaryNameRow, embSummaryName, data.line1);
    setSummaryTextLine(embSummaryDepartmentRow, embSummaryDepartment, data.line2);
    setSummaryTextLine(embSummaryOtherRow, embSummaryOther, data.line3);

    if (embSummaryImg && mainImage) {
      embSummaryImg.src = mainImage.src;
      embSummaryImg.style.display = 'block';
    }

    embSummary.classList.add('is-visible');
    if (embTrigger) embTrigger.classList.add('is-hidden');
  }

  function clearSummary() {
    if (embSummary) embSummary.classList.remove('is-visible');
    if (embTrigger) {
      embTrigger.classList.remove('is-hidden');
      var span = embTrigger.querySelector('span');
      if (span) span.textContent = 'ADD TEXT EMBROIDERY';
    }
  }

  function renderGalleryOverlay(data) {
    if (!scrubOverlayText) return;
    scrubOverlayText.classList.remove('is-visible'); // product image te kade na dikhao
  }

  var embFormError = document.getElementById('emb-form-error');

  function showEmbError(message) {
    if (!embFormError) return;
    embFormError.textContent = message;
    embFormError.classList.add('is-visible');
  }

  function clearEmbError() {
    if (!embFormError) return;
    embFormError.textContent = '';
    embFormError.classList.remove('is-visible');
  }

  if (embApply) {
    embApply.addEventListener('click', function() {
      clearEmbError();

      var fsVal = embFontStyle.value;
      var fcVal = embFontColor.value;
      var plVal = embPlacement.value;
      var l1Val = embLine1 ? embLine1.value.trim() : '';

      if (!fsVal) { showEmbError('Please select a Font Style.'); return; }
      if (!fcVal) { showEmbError('Please select a Font Color.'); return; }
      if (!plVal) { showEmbError('Please select a Text Placement.'); return; }
      if (!l1Val) { showEmbError('Please enter a Name.'); return; }

      var l2Val = embLine2 ? embLine2.value.trim() : '';
      var l3Val = embLine3 ? embLine3.value.trim() : '';

      var lineCount = [l1Val, l2Val, l3Val].filter(Boolean).length;
      var priceCents = lineCount >= 3 ? embConfig.price_3_lines : embConfig.price_1_2_lines;
      var chargeVariantId = lineCount >= 3 ? embConfig.variant_3_lines : embConfig.variant_1_2_lines;

      window.embroideryData = {
        applied: true,
        font_style: fsVal,
        font_style_label: fontLabel(fsVal),
        font_color: fcVal,
        font_color_label: colorLabel(fcVal),
        placement: plVal,
        line1: l1Val,
        line2: l2Val,
        line3: l3Val,
        priceCents: priceCents,
        chargeVariantId: chargeVariantId
      };

      renderSummary(window.embroideryData);
      renderGalleryOverlay(window.embroideryData);
      renderPrice();
      closeEmb();
    });
  }

  if (embSummaryEdit) {
    embSummaryEdit.addEventListener('click', function() {
      if (window.embroideryData) {
        if (embFontStyle) embFontStyle.value = window.embroideryData.font_style;
        if (embFontColor) embFontColor.value = window.embroideryData.font_color;
        if (embPlacement) embPlacement.value = window.embroideryData.placement;
        if (embLine1) { embLine1.value = window.embroideryData.line1; embCounter1.textContent = embLine1.value.length + '/25'; }
        if (embLine2) { embLine2.value = window.embroideryData.line2; embCounter2.textContent = embLine2.value.length + '/25'; }
        if (embLine3) { embLine3.value = window.embroideryData.line3; embCounter3.textContent = embLine3.value.length + '/25'; }
        updateLivePreview();
      }
      openEmb();
    });
  }

  if (embSummaryRemove) {
    embSummaryRemove.addEventListener('click', function() {
      window.embroideryData = { applied: false, priceCents: 0 };
      clearSummary();
      renderGalleryOverlay(null);
      renderPrice();
      if (embLine1) embLine1.value = '';
      if (embLine2) embLine2.value = '';
      if (embLine3) embLine3.value = '';
      if (embCounter1) embCounter1.textContent = '0/25';
      if (embCounter2) embCounter2.textContent = '0/25';
      if (embCounter3) embCounter3.textContent = '0/25';
      if (embFontStyle) embFontStyle.value = '';
      if (embFontColor) embFontColor.value = '';
      if (embPlacement) embPlacement.value = '';
      if (embPreviewLiveText) embPreviewLiveText.classList.remove('is-visible');
    });
  }

})();
  